type Injectable<T extends Record<string, any>> = T & {
	inject: (overrides: Partial<T>) => void;
};

export function createInjectable<T extends Record<string, any>>(defaults: T): Injectable<T> {
	const api = {
		...defaults,
	} as Injectable<T>;

	const proxy = new Proxy(api, {
		get(target, key: string) {
			const value = target[key];

			// 让外面自己绑定吧
			// if (typeof value === 'function') {
			// 	return value.bind(target);
			// }

			return value;
		},

		set(target, key, value) {
			target[key as keyof T] = value;
			return typeof key === 'string' && key in target;
		},
	});

	api.inject = (overrides: Partial<T>) => {
		Object.keys(overrides).forEach((key) => {
			api[key as keyof T] = overrides[key]!;
		});
	};

	return proxy;
}
